import BreadcrumbLink from '@/shared/ui/components/BreadcrumbLink';
import type { RoutePathDefinition } from '../../types';

export const ccmSectionRoutes: RoutePathDefinition[] = [
  {
    path: 'patients',
    lazy: () => import('@/pages/chronic-care-management/ui/CcmPatients').then(m => ({ Component: m.default })),
    handle: { crumb: () => <BreadcrumbLink>CCM Patients</BreadcrumbLink> }
  }
];
